/**
 * Combined Listings — PDP helper.
 *
 * When <product-hot-reload> swaps the PDP to a sibling colour (Section
 * Rendering API), third-party app widgets inside the swapped markup are
 * re-rendered as empty placeholders because their JS only scanned the DOM
 * on first load. This re-initialises known widgets after each swap.
 *
 * Guarded: every call is a no-op if the app/API isn't present, so this is
 * safe regardless of which apps are installed.
 */
(function () {
  function reinitWidgets() {
    // Yotpo (v3 widgets)
    try {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      } else if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
        // Legacy Yotpo
        window.yotpo.refreshWidgets();
      }
    } catch (e) {
      /* no-op */
    }

    // Klaviyo Back in Stock — re-bind after the hot-reload swap (see below).
    scheduleKlaviyoReinit();
  }

  /*
   * Klaviyo's back-in-stock trigger is bound at onsite init and is NOT re-bound
   * when <product-hot-reload> replaces the form DOM, so the swapped-in button
   * won't open the modal. We re-init Klaviyo (assets/sr-klaviyo-back-in-stock)
   * after a swap — but ONLY when a sold-out variant is showing (a
   * .klaviyo-bis-trigger exists), to avoid needless onsite.js re-injection.
   *
   * Timing matters: Klaviyo derives the product from location.pathname and the
   * selected variant from the ?variant= URL param. <product-hot-reload> updates
   * window.history (the URL) only AFTER its View Transition finishes — i.e.
   * AFTER the DOM mutation that fires this observer. Re-initialising too early
   * makes Klaviyo read a stale URL and build an empty product model, which then
   * crashes its showModal (`unavailable_variants[0].id` on an empty array). So
   * we wait until the URL's variant matches the swapped-in component's
   * data-variant-id before re-initialising.
   */
  function scheduleKlaviyoReinit() {
    if (!document.querySelector('.klaviyo-bis-trigger')) return;
    if (typeof window.reinitKlaviyoBackInStock !== 'function') return;

    var host = document.querySelector('product-hot-reload');
    var expectedVariant = host && host.dataset.variantId;
    var tries = 0;

    (function waitForUrl() {
      var current = new URLSearchParams(window.location.search).get('variant');
      if (!expectedVariant || current === expectedVariant || tries >= 30) {
        try {
          window.reinitKlaviyoBackInStock();
        } catch (e) {
          /* no-op */
        }
      } else {
        tries++;
        setTimeout(waitForUrl, 50); // wait up to ~1.5s for history.pushState
      }
    })();
  }

  function observe() {
    document.querySelectorAll('product-hot-reload').forEach(function (el) {
      if (el.dataset.clWidgetObserver) return;
      el.dataset.clWidgetObserver = 'true';

      var debounce;
      var observer = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(reinitWidgets, 150);
      });
      // The component replaces its innerHTML wholesale, so watching direct
      // children is enough (no subtree) — cheap and fires once per swap.
      observer.observe(el, { childList: true });
    });
  }

  if (document.readyState !== 'loading') {
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', observe);
  }
})();
